// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","logo":"Header_logo__UsziS","right-block":"Header_right-block__cl49S","nav":"Header_nav__J8WFt"};